<div class="animated fadeIn container-fluid" [formGroup]="form">
    <h4>{{ title }} Declaración Suplementaria</h4>

    <div class="row">
        <div class="col-md-12">

            <div class="row">

                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos de la Declaración Suplementaria
                                <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                <div class="row">

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpCampania">Campaña</label>

                                        <ng-select [items]="listCampanias"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdCampania"
                                                   loadingText="Cargando..."
                                                   [loading]="!(listCampanias)"
                                                   notFoundText="Campaña no encontrada"
                                                   placeholder="-- Seleccione una Campaña --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdCampania')"
                                                   appendTo="body"
                                                   [readonly]="declaracionSuplementaria?.FechaBaja">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCampania','required')">
                                            La campaña es obligatoria
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="intDescripcion">Fecha de Creación</label>
                                        <input formControlName="FechaCreacion" name="FechaCreacion" class="form-control" readonly inputStyleClass="form-control" [ngClass]="displayFieldCss('FechaCreacion')" value="">
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="intDescripcion">Fecha de Baja</label>
                                        <input formControlName="FechaBaja" name="FechaBaja" class="form-control" readonly inputStyleClass="form-control" [ngClass]="displayFieldCss('FechaBaja')" value="">
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpTipoTextoDeclaracionSuplementaria">Tipo de Texto Declaración Suplementaria</label>

                                        <ng-select [items]="listTipoTextoDeclaracionSuplementaria"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdTipoTextoDecSuplementariaCam"
                                                   loadingText="Cargando..."
                                                   [loading]="!(listTipoTextoDeclaracionSuplementaria)"
                                                   notFoundText="Tipo de texto no encontrado"
                                                   placeholder="-- Seleccione un Tipo --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdTipoTextoDecSuplementariaCam')"
                                                   appendTo="body"
                                                   [readonly]="declaracionSuplementaria?.FechaBaja">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdTipoTextoDecSuplementariaCam','required')">
                                            El tipo es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="intDescripcion">Pregunta</label>
                                        <input formControlName="DescripcionTexto" name="DescripcionTexto" class="form-control" maxlength="100" inputStyleClass="form-control" [ngClass]="displayFieldCss('DescripcionTexto')" type="text" value="" [readonly]="declaracionSuplementaria?.FechaBaja">

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('DescripcionTexto','required')">
                                            La pregunta es obligatoria
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="inpActiva">Activa</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="Activa" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times" [disabled]="declaracionSuplementaria?.FechaBaja"></p-toggleButton>
                                    </div>

                                    <div class="form-group col-md-12">
                                        <label class="col-form-label required-field" for="intDescripcion">Texto de la Declaración Suplementaria</label>
                                        <textarea style="resize:none" formControlName="TextoDecSuplementaria" name="TextoDecSuplementaria" class="form-control" maxlength="8000" inputStyleClass="form-control" rows="12" [ngClass]="displayFieldCss('TextoDecSuplementaria')" type="text" value="" [readonly]="declaracionSuplementaria?.FechaBaja"></textarea>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('TextoDecSuplementaria','required')">
                                            El texto es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" for="intDescripcion">Observaciones</label>
                                        <textarea style="resize:none" formControlName="Observaciones" name="Observaciones" maxlength="1000" type="text" class="form-control" inputStyleClass="form-control" rows="8" value="" [readonly]="declaracionSuplementaria?.FechaBaja"></textarea>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

</div>
